module.exports = __webpack_public_path__ + "static/img/pic_WORD_vip@2x.d128fdf0.png";